import * as React from 'react'
import {
  Root as AvatarRoot,
  Image as AvatarImage,
  Fallback as AvatarFallback,
} from '@radix-ui/react-avatar'

import { cn } from '@/lib/utils'

const Avatar: React.FC<React.ComponentProps<typeof AvatarRoot>> = ({
  className,
  ...props
}) => (
  <AvatarRoot
    className={cn(
      'relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full',
      className,
    )}
    {...props}
  />
)
Avatar.displayName = AvatarRoot.displayName

const AvatarImageComponent: React.FC<
  React.ComponentProps<typeof AvatarImage>
> = ({ className, ...props }) => (
  <AvatarImage
    className={cn('aspect-square h-full w-full', className)}
    {...props}
  />
)
AvatarImageComponent.displayName = AvatarImage.displayName

const AvatarFallbackComponent: React.FC<
  React.ComponentProps<typeof AvatarFallback>
> = ({ className, ...props }) => (
  <AvatarFallback
    className={cn(
      'flex h-full w-full items-center justify-center rounded-full bg-muted',
      className,
    )}
    {...props}
  />
)
AvatarFallbackComponent.displayName = AvatarFallback.displayName

export {
  Avatar,
  AvatarImageComponent as AvatarImage,
  AvatarFallbackComponent as AvatarFallback,
}
